import React, { useContext } from 'react'
import Context from '../../Context'
import { Box, Divider, Drawer, IconButton, useTheme } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import MenuGroups from './MenuGroups'
import Bookmakers from './Bookmakers'

function SideBar({ sideBarWidth }) {
  const { isSideBarOpen, setIsSideBarOpen  } = useContext(Context)
  const theme = useTheme()

  const toggleSideBar = () => {
    setIsSideBarOpen(!isSideBarOpen)
  }

  return(
    <Drawer
      anchor="left"
      variant="persistent"
      open={isSideBarOpen}
      onClose={toggleSideBar}
      // the menu is taller than the window and scrolls. The dark colour has to live on the sheet that
      // scrolls with it, otherwise everything past one screen falls off the painted area and the light
      // paper shows through wherever an item does not paint its own background — the gaps at the dividers
      PaperProps={{ sx: { backgroundColor: theme.palette.primary.main } }}
      slotprops={{
        backdrop: {
          style: { backgroundColor: 'transparent' },
        },
      }}
    >
      <Box
        sx={{ width: sideBarWidth, backgroundColor: theme.palette.primary.main, minHeight: '100%' }}
        role="presentation"
      >
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '5px' }}
        >
          <IconButton onClick={toggleSideBar} style={{ transform: 'rotate(180deg)', color: 'white' }}>
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
        <Bookmakers />
        <Divider />
        <MenuGroups />
      </Box>
    </Drawer>
  )
}

export default SideBar